// src/Components/Streak/RewardChips.tsx
// A milestone reward as resource chips (stars, coins, moonrocks), zeros hidden.
import React from "react";
import StatChip from "../Ui/StatChip";
import { Reward } from "./streakModel";

const S3 = "https://moonrock-images.s3.us-east-2.amazonaws.com/";
export const REWARD_ICON = {
  stars: S3 + "Star-Resource.png",
  coins: S3 + "GoldCoin9.png",
  moonrocks: S3 + "moonrockIcon.png",
} as const;

const RewardChips: React.FC<{ reward: Reward; size?: "sm" | "md"; className?: string }> = ({ reward, size = "sm", className = "" }) => (
  <span className={`streak-rewards ${className}`}>
    {(["stars", "coins", "moonrocks"] as const)
      .filter((k) => reward[k] > 0)
      .map((k) => (
        <StatChip key={k} kind={k} iconSrc={REWARD_ICON[k]} value={`+${reward[k].toLocaleString("en-US")}`} size={size} ariaLabel={`${reward[k]} ${k}`} />
      ))}
  </span>
);

export default RewardChips;
